import React from 'react'

const Unsubscribe = () => {
    return (
        <svg width="22" height="24" cursor="pointer" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.27273 8.27273V3.72727C8.27273 3.00396 8.56006 2.31026 9.07153 1.7988C9.58299 1.28734 10.2767 1 11 1H18.2727C18.996 1 19.6897 1.28734 20.2012 1.7988C20.7127 2.31026 21 3.00396 21 3.72727V20.0909C21 20.8142 20.7127 21.5079 20.2012 22.0194C19.6897 22.5308 18.996 22.8182 18.2727 22.8182H11C10.2767 22.8182 9.58299 22.5308 9.07153 22.0194C8.56006 21.5079 8.27273 20.8142 8.27273 20.0909V15.5455M4.63636 15.5455L1 11.9091M1 11.9091L4.63636 8.27273M1 11.9091H16.4545" stroke="#FE0202" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
}

export default Unsubscribe